import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { getCsrfToken } from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

const GENDERCODE = { MALE: "1", FEMALE: "2" }

declare global {
  interface Window { AjaxZip3: any; }
}


const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // 患者情報
  const [patient, setPatient] = useState({name: "", phone_number: "", gender_type: "", birthday: "", zip_code: "", address1: "", address2: "", phone_disable: false});
  
  // 退会処理表示用
  const [deletableFlag, setDeletableFlag] = useState<Boolean>(true);

  // ロード用
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // エラーメッセージ
  const [errorMessage, setErrorMessage]  = useState<String>("");
  // 初回ロード
  useEffect(() =>{
    axios.get(
      '/api/internal/reserves/get_profile?m_institution_key=' + props.institution_key, {})
      .then(function (response) {
        if (response.data.is_login) {
          let m_patient = response.data.m_patient
          let birthday = ""
          if (m_patient.birthday.yaer != ""){
            birthday = `${m_patient.birthday.year}-${m_patient.birthday.month}-${m_patient.birthday.day}`
          }
          setPatient({name: m_patient.name, phone_number: m_patient.mobilePhoneNumber, gender_type: m_patient.genderKbn, birthday: birthday, zip_code: m_patient.zipCode, address1: m_patient.address1, address2: m_patient.address2, phone_disable: m_patient.phone_number_disable});
        
          // 必須項目がない場合は、退会できないように修正
          if( m_patient.name === null || m_patient.gender_type === "" || m_patient.birthday.year === null) {
            setDeletableFlag(false);
          }
        }
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
      });
  },[])

  // 患者更新
  function submitPatient(){
    setIsLoading(true);
    axios.post('/api/internal/reserves/update_profile',{m_institution_key: props.institution_key, patient: patient})
      .then(function (response) {
        location.href = (`new`);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      }
    );
  }

  return(
    <LoadingOverlay active={isLoading} spinner text='Loading...' >
    {errorMessage && 
      <div className="alert alert-danger alert-dismissible" role="alert">
        <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>{errorMessage}
      </div>
    }
    <div className="row">
      <div className="col-xs-1  col-sm-1 col-md-2 col-lg-3"/>
      <div className="col-xs-10 col-sm-10 col-md-8 col-lg-6">
        <h3 className="h3">プロフィール</h3>
        <div className="form-group">
          <label htmlFor="name">お名前</label><span className="label label-danger ml5">必須</span>
            <input 
              className="form-control"
              placeholder="グッド　太郎"
              type="text" 
              id="name"
              value={patient.name}
              defaultValue={patient.name}
              onChange={(e) => setPatient({...patient, name: e.target.value})}
            />
        </div>
        <div className="form-group">
          <label>性別</label><span className="label label-danger ml5">必須</span>
          <br/>
          <div className="radio-inline">
            <input 
              className="radio-input" 
              type="radio" 
              value={ GENDERCODE.MALE }
              id="gender_kbn_male" 
              name="gender_kbn"
              checked={ patient.gender_type === GENDERCODE.MALE  }
              onChange={(e) => setPatient({...patient, gender_type: e.target.value})}
              
            />
            <label className="m10" htmlFor="gender_kbn_male">男性</label>
            <input 
              className="radio-input"
              type="radio"
              value={ GENDERCODE.FEMALE }
              id="gender_kbn_female"
              name="gender_kbn"
              checked={ patient.gender_type === GENDERCODE.FEMALE }
              onChange={(e) => setPatient({...patient, gender_type: e.target.value})}
            />
            <label className="m10" htmlFor="gender_kbn_female">女性</label>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="birthday">生年月日</label><span className="label label-danger ml5">必須</span>
            <input 
              type="date"
              className="form-control w50p"
              name="birthday"
              autoComplete="off"
              min="1900-01-01"
              value={patient.birthday}
              defaultValue={patient.birthday}
              onChange={(e) => setPatient({...patient, birthday: e.target.value})}
              >
            </input>
        </div>
        <div className="form-group">
          <label htmlFor="mobile_phone_number">携帯番号</label>
            <input 
              className="form-control w50p"
              placeholder="08000000000"
              type="text"
              id="mobile_phone_number"
              value={patient.phone_number}
              defaultValue={patient.phone_number}
              disabled={patient.phone_disable}
              onChange={(e) => setPatient({...patient, phone_number: e.target.value})}
            />
        </div>
        <div className="form-group">
          <label htmlFor="zip_code">郵便番号（ハイフンなし）</label>
            <input  
              type="tel"
              id="address"
              name="zipCode"
              className="form-control w50p"
              autoComplete="off"
              maxLength={8}
              placeholder="100000"
              value={patient.zip_code}
              defaultValue={patient.zip_code}
              onChange={(e) => setPatient({...patient, zip_code: e.target.value})}
              onBlur={(e) => {
                window.AjaxZip3.zip2addr('zipCode','','address1','address1');
              }}
            />
          <label htmlFor="address1">住所</label>
          <input
            type="text"
            id="address1"
            name="address1"
            className="form-control"
            autoComplete="off"
            maxLength={255}
            placeholder="東京都千代田区"
            value={patient.address1}
            defaultValue={patient.address1}
            onBlur={(e) => setPatient({...patient, address1: e.target.value})}
          />
          <input
            type="text"
            id="address2"
            name="address2"
            className="form-control"
            autoComplete="off"
            maxLength={255}
            value={patient.address2}
            defaultValue={patient.address2}
            onChange={(e) => setPatient({...patient, address2: e.target.value})}
          />
        </div>
        {
          deletableFlag && (
            <div className="bold">
              退会する場合は<a className="under blue reserves_link" href={`/${props.institution_key}/reserves/account_delete/confirm`}>こちら</a>から
            </div>
          )
        }

        <div className="col-xs-1 col-sm-1 col-md-2 col-lg-3"/>
        {/* ボタン類 */}
        <div>
          <div className="actions mt40">
              <a className="btn btn-primary pull-left m5" href={`/${props.institution_key}/reserves/new`}>戻る</a>
              <a className="btn btn-primary pull-right m5" onClick={() => submitPatient()}>
                更新する
              </a>
          </div>
        </div>
      </div>
    </div>
    </LoadingOverlay>
  )
}
export default Index;